import { setLocale, useLocale } from '../i18n/react';
import { localeRepository } from '../i18n/repository';
import { languageHref, readBrowserRoute } from '../routing/browser';

export function LanguageSwitch() {
  const locale = useLocale();
  const admin = readBrowserRoute().view === 'admin';
  return <div className="language-switch" role="group" aria-label="Ngôn ngữ / Language">
    {admin ? <>
      <button type="button" lang="vi" aria-label="Tiếng Việt" aria-pressed={locale === 'vi'} onClick={() => setLocale('vi')}>VI</button>
      <button type="button" lang="en" aria-label="English" aria-pressed={locale === 'en'} onClick={() => setLocale('en')}>EN</button>
    </> : <>
      <a href={languageHref('vi')} lang="vi" hrefLang="vi" aria-label="Tiếng Việt" aria-current={locale === 'vi' ? 'page' : undefined} onClick={() => localeRepository.write('vi')}>VI</a>
      <a href={languageHref('en')} lang="en" hrefLang="en" aria-label="English" aria-current={locale === 'en' ? 'page' : undefined} onClick={() => localeRepository.write('en')}>EN</a>
    </>}
  </div>;
}
